/**
 * Coordinates for center of Germany.
 */
export const FARMACT_DEFAULT_LOCATION = { lng: 10.4515, lat: 51.1657 };
